import clsx from 'clsx';
import React from 'react';
import useSwiperRef from './hooks/useSwiperRef';
import styles from './Carousel.module.scss';
import { Navigation } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';
import { Swiper as ReactSwiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/a11y';
import 'swiper/css/navigation';
import 'swiper/css/grid';
import { SkipToNextBlock } from '../SkipToNextBlock.ts';

export interface CarouselProps {
    /**
     * A list of items to be shown in a slide
     */
    items?: React.ReactNode[];
    prevRef?: React.RefObject<HTMLButtonElement>;
    nextRef?: React.RefObject<HTMLButtonElement>;
    options?: SwiperOptions;
    isSkipHidden?: boolean;
    className?: string;
    swiperClassName?: string;
}

export const Carousel = ({
    items,
    prevRef: initialPrevRef,
    nextRef: initialNextRef,
    isSkipHidden,
    options = {},
    className,
    swiperClassName,
}: CarouselProps) => {
    const { element: prevEl } = useSwiperRef({ ref: initialPrevRef });
    const { element: nextEl } = useSwiperRef({ ref: initialNextRef });

    const config: SwiperOptions = {
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        watchOverflow: true,
        navigation: {
            prevEl,
            nextEl,
        },
        modules: [Navigation],
        updateOnWindowResize: true,
        ...options,
    };

    return (
        <div className={clsx(styles.carouselContainer, className)}>
            {!isSkipHidden && <SkipToNextBlock />}
            <ReactSwiper className={clsx(styles.carouselSwiper, swiperClassName)} {...config}>
                {items?.map((item, index) => (
                    <SwiperSlide
                        className={styles.carouselSlide}
                        data-testid="category-link"
                        key={index}
                    >
                        {item}
                    </SwiperSlide>
                ))}
            </ReactSwiper>
        </div>
    );
};
